<template>
    <div class="article-item" v-if="item.articles.length==1" :class="{'pointer':type=='select'}">
        <div class="active-box" v-if="type=='select'">
            <i class="icon-gouxuan"></i>
        </div>
        <div :class="{'open-btn':isOpen()}" @click="openArticle(item,$event)">
            <div class="title">{{item.title}}</div>
            <img :src="item.thumb_url" v-if="item.thumb_url">
            <div class="desc">{{item.digest}}</div>
        </div>
        <div class="info-box" v-if="isOpen()">
            <div class="time">更新于 {{item.updateTime|formatDate("yyyy年MM月dd日")}}</div>
            <div v-if="!type">
                <i class="icon-shanchu" @click="delArticle(item)"></i>
            </div>
        </div>
    </div>
    <div class="article-item article-item2" v-else :class="{'pointer':type=='select'}">
        <div class="active-box" v-if="type=='select'">
            <i class="icon-gouxuan"></i>
        </div>
        <div class="item-top" :class="{'open-btn':isOpen()}" @click="openArticle(item,$event)">
            <div class="title">{{item.title}}</div>
            <img :src="item.thumb_url">
        </div>
        <div class="child-list">
            <div class="child-item" :class="{'open-btn':isOpen()}" @click="openArticle(item2,$event)" v-for="(item2,i) in item.articles" :key="i">
                <div class="child-title">{{item2.title}}</div>
                <img class="child-img" :src="item2.thumb_url">
            </div>
        </div>
        <div class="info-box" v-if="isOpen()">
            <div class="time">更新于 {{(item.updateTime||item.createTime)|formatDate("yyyy年MM月dd日")}}</div>
            <div v-if="!type">
                <i class="icon-shanchu" @click="delArticle(item)"></i>
            </div>
        </div>
    </div>
</template>
<script>
    //当前实例组件
    export default {
        props:{
            type:null,
            item:null
        },
        data: () => ({

        }),
        components: {},
        mounted() {

        },
        methods: {
            isOpen(){
                return (this.type!='formLook'&&this.type!='select');
            },
            delArticle(item){
                this.$emit("del",item.id);
            },
            openArticle(item,e){
                if(!this.isOpen()){
                    return;
                }
                e.stopPropagation();
                window.open(item.url);
            }
        },
    };
</script>
<style lang="scss">
.article-item {
    padding: 20px 15px;
    width: 100%;
    background-color: #fff;
    margin-bottom: 15px;
    &.pointer {
        cursor: pointer;
    }
    .open-btn {
        position: relative;
        &:hover::before {
            display: flex;
        }
        &::before {
            content: "查看文章";
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            justify-content: center;
            align-items: center;
            background-color: #000;
            color: #fff;
            font-size: 18px;
            cursor: pointer;
            z-index: 2;
        }
    }
    .active-box {
        display: none;
    }
    .active{
        position: relative;
        .active-box {
            display: flex;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.5);
            justify-content: center;
            align-items: center;
            color: #fff;
            font-size: 30px;
            z-index: 1;
        }
    }
    .title {
        font-size: 16px;
        margin-bottom: 15px;
    }
    img {
        width: 100%;
    }
    .desc {
        margin-top: 10px;
        font-size: 14px;
        color: #999;
    }
    .info-box {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #999;
        i {
            font-size: 20px;
            cursor: pointer;
        }
    }
    &.article-item2 {
        .item-top {
            position: relative;
            .title {
                background-color: rgba(0,0,0,0.6);
                color: #fff;
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                padding: 7px;
                margin-bottom: 0;
            }
        }
        .child-list {
            margin-top: 5px;
            .child-item {
                padding: 10px 0;
                justify-content: space-between;
                border-top: 1px solid #ddd;
                .child-title {
                    width: calc(100% - 62px);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-inline-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    margin-right: 6px;
                    font-size: 14px;
                }
                .child-img {
                    display: inline-block;
                    width: 50px;
                    height: 50px;
                    vertical-align: top;
                }
            }
        }
    }
}
</style>
